//#region src/redux/notification/initial-state.ts
var notificationInitialState = { notification: null };
//#endregion
export { notificationInitialState };

//# sourceMappingURL=initial-state.js.map